import { css } from "emotion";
import Image from "../../components/Image";
import ColorServices from "../../services/ColorServices";

const childWrapper = css({
  maxWidth: 1200,
  width: "100%",
  margin: "0 auto"
});

const imageStylingRight = css({
  maxHeight: 418,
  width: "auto",
  position: "absolute",
  top: 16,
  left: "48%",
  "@media(max-width: 1080px)": {
    position: "relative",
    top: "auto",
    left: "auto",
    margin: "0 auto",
    display: "block",
    marginBottom: 40
  }
});

const Banner = ({ image, bgColor = "purpleMid", alt = "", children }) => {
  const wrapper = css({
    backgroundColor: ColorServices.getColor(bgColor),
    color: ColorServices.getColor("white"),
    position: "relative",
    overflow: "hidden",
    height: 450,
    display: "flex",
    alignItems: "center",
    "@media(max-width: 1080px)": {
      display: "block",
      height: "auto"
    }
  });
  return (
    <div className={wrapper}>
      <div className={childWrapper}>{children}</div>
      <Image imageURL={image} styleSheet={imageStylingRight} alt={alt} />
    </div>
  );
};

export default Banner;
